import { render, staticRenderFns } from "./todayAcount.vue?vue&type=template&id=45bc72a8&scoped=true&"
import script from "./todayAcount.vue?vue&type=script&lang=js&"
export * from "./todayAcount.vue?vue&type=script&lang=js&"
import style0 from "./todayAcount.vue?vue&type=style&index=0&id=45bc72a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bc72a8",
  null
  
)

export default component.exports